(() => {
  'use strict';

  const init = (root = document) => {
    const sections = [];
    if (root instanceof Element && root.matches('.c1cmp')) sections.push(root);
    root.querySelectorAll?.('.c1cmp').forEach((section) => sections.push(section));

    sections.forEach((section) => {
      if (section.dataset.c1ComparisonReady === 'true') return;
      section.dataset.c1ComparisonReady = 'true';

      const list = section.querySelector('[data-c1cmp-tablist]');
      const previous = section.querySelector('[data-c1cmp-prev]');
      const next = section.querySelector('[data-c1cmp-next]');
      if (!list || !previous || !next) return;

      const tabs = [...list.querySelectorAll('.c1cmp__tab')];
      const isRtl = () => getComputedStyle(list).direction === 'rtl';
      const activeIndex = () => {
        const listRect = list.getBoundingClientRect();
        const edge = isRtl() ? listRect.right : listRect.left;
        let index = 0;
        let distance = Number.POSITIVE_INFINITY;

        tabs.forEach((tab, tabIndex) => {
          const tabRect = tab.getBoundingClientRect();
          const tabEdge = isRtl() ? tabRect.right : tabRect.left;
          const nextDistance = Math.abs(tabEdge - edge);
          if (nextDistance < distance) {
            distance = nextDistance;
            index = tabIndex;
          }
        });
        return index;
      };

      const update = () => {
        const index = activeIndex();
        previous.disabled = index === 0;
        next.disabled = index === tabs.length - 1;
        previous.classList.toggle('is-disabled', previous.disabled);
        next.classList.toggle('is-disabled', next.disabled);
      };

      const goTo = (index) => {
        const target = tabs[Math.max(0, Math.min(tabs.length - 1, index))];
        if (target) {
          const targetRect = target.getBoundingClientRect();
          const listRect = list.getBoundingClientRect();
          const distance = isRtl() ? targetRect.right - listRect.right : targetRect.left - listRect.left;
          list.scrollBy({ left: distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
        window.setTimeout(update, 220);
      };

      previous.addEventListener('click', () => goTo(activeIndex() - 1));
      next.addEventListener('click', () => goTo(activeIndex() + 1));
      list.addEventListener('scroll', update, { passive: true });
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          const tabRect = tab.getBoundingClientRect();
          const listRect = list.getBoundingClientRect();
          list.scrollBy({ left: tabRect.left + tabRect.width / 2 - listRect.left - listRect.width / 2, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
        window.setTimeout(update, 220);
      }));
      window.addEventListener('resize', update, { passive: true });
      requestAnimationFrame(update);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
})();
